import React from "react";
import { Input } from "@";
import MultiSearchForm from "@/shared/components/form/MultiSearchForm";
import type { RecipientsSearchState } from "../types";
import { RecipientStatus } from "../types";

interface RecipientsFilterProps {
  search: RecipientsSearchState;
  updateSearch: (updates: Partial<RecipientsSearchState>) => void;
  onSubmit: () => void;
  onReset: () => void;
}

const statusOptions = [
  { id: RecipientStatus.Queued, name: "في الانتظار" },
  { id: RecipientStatus.Sent, name: "تم الإرسال" },
  { id: RecipientStatus.Failed, name: "فشل" },
];

const RecipientsMultiSearch: React.FC<RecipientsFilterProps> = ({
  search,
  updateSearch,
  onSubmit,
  onReset,
}) => {
  const handleInputChange = (field: string, value: Date | null) => {
    updateSearch({
      values: { ...search.values, [field]: value },
    });
  };
  return (
    <MultiSearchForm
      show={search.show}
      onSubmit={onSubmit}
      className="multi-search-form xl:grid-cols-6"
      reset={onReset}
      style={undefined}
    >
      <Input
        star
        label="اسم المستخدم"
        value={search.values.userName}
        change={(e: { target: { value: any } }) =>
          handleInputChange("userName", e.target.value)
        }
      />

      <Input
        star
        label="رقم الهاتف"
        value={search.values.phoneNumber}
        change={(e: { target: { value: any } }) =>
          handleInputChange("phoneNumber", e.target.value)
        }
      />

      <Input
        star
        type="select"
        label="الحالة"
        list={statusOptions}
        value={search.values.status}
        change={(e: { target: { value: any } }) =>
          handleInputChange("status", e.target.value)
        }
      />

      <Input
        star
        showTimeSelect
        type="date-range"
        labelA="تاريخ الإرسال من"
        labelB="تاريخ الإرسال إلى"
        style="xl:col-span-2"
        valueA={search.values.sentAtFrom}
        valueB={search.values.sentAtTo}
        changeA={(date: Date | null) => handleInputChange("sentAtFrom", date)}
        changeB={(date: Date | null) => handleInputChange("sentAtTo", date)}
      />
    </MultiSearchForm>
  );
};

export default RecipientsMultiSearch;
